import React from 'react';

const NotFound = () => {
    return (
        <div>Notfound</div>
      );
}
 
export default NotFound;